import { createFileRoute, redirect } from '@tanstack/react-router';

import { permittingPathFor } from '../modules/Permits/permitAdminRedirect';

// Permitting moved to /permitting. An old request link opens the request page, an old
// permit link the permit page (permitAdminRedirect.ts); the query and hash come along.
export const Route = createFileRoute('/permitAdmin/$')({
  beforeLoad: ({ params, location }) => {
    throw redirect({
      href: `${permittingPathFor(params._splat)}${location.searchStr ?? ''}${location.hash ? `#${location.hash}` : ''}`,
      replace: true,
    });
  },
});
